module.exports = __webpack_public_path__ + "img/Path 24 Copy@3x.6688c5cb.png";